import * as fetch from "../../common/fetch";

import { GroupCreateRequestType, GroupDeleteRequestType } from "../requests/groupRequestTypes";

import {
  GroupGetResponseType,
  GroupGetAllResponseType,
  GroupGetUsersResponseType,
  GroupGetRolesResponseType,
  GroupGetPoliciesResponseType
} from "../responses/groupResponseTypes";

const url = process.env.WIB_API_URL;

export async function getAll() {
  const response = await fetch.get(`${url}/groups`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetAllResponseType;
  }
}

export async function getById(id) {
  const response = await fetch.get(`${url}/groups/${id}`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetResponseType;
  }
}

export async function getUsers(id) {
  const response = await fetch.get(`${url}/groups/${id}/users`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetUsersResponseType;
  }
}

export async function getRoles(id) {
  const response = await fetch.get(`${url}/groups/${id}/roles`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetRolesResponseType;
  }
}

export async function getPolicies(id) {
  const response = await fetch.get(`${url}/groups/${id}/policies`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetPoliciesResponseType;
  }
}

export async function create(body: GroupCreateRequestType) {
  const response = await fetch.post(`${url}/groups`, body);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetResponseType;
  }
}

export async function del(id, body: GroupDeleteRequestType) {
  const response = await fetch.del(`${url}/groups/${id}`, body);
  return response.ok;
}
